import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { ASSETS } from "@/lib/content";

const LINKS = [
  { label: "How it works", href: "#how-it-works" },
  { label: "Features", href: "#features" },
  { label: "Support", href: "#support" },
  { label: "Privacy", href: "#privacy" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "border-b border-black/5 bg-[#faf4e0]/80 backdrop-blur-xl"
          : "border-b border-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-8">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-2.5">
          <img src={ASSETS.appIcon} alt="Purrse" className="h-10 w-10 rounded-xl shadow-sm" />
          <span className="font-heading text-xl font-extrabold tracking-tight text-gray-900">
            Purrse
          </span>
        </a>

        <div className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              className="text-sm font-semibold text-gray-700 transition-colors hover:text-emerald-600"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#download"
            data-testid="nav-cta"
            className="rounded-full bg-emerald-500 px-6 py-2.5 text-sm font-bold text-white shadow-lg shadow-emerald-500/30 transition-all hover:-translate-y-0.5 hover:bg-emerald-600"
          >
            Get the app
          </a>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-gray-900"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {open && (
        <div className="border-t border-black/5 bg-[#faf4e0]/95 backdrop-blur-xl md:hidden">
          <div className="flex flex-col gap-1 px-6 py-4">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.href.replace("#", "")}`}
                className="rounded-xl px-3 py-3 text-base font-semibold text-gray-800 hover:bg-white/60"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#download"
              onClick={() => setOpen(false)}
              className="mt-2 rounded-full bg-emerald-500 px-6 py-3 text-center text-base font-bold text-white"
            >
              Get the app
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
